// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.ThemeList ul {
    padding: 0;
    list-style-type: none;
}

div.ThemeList li.theme-group-header > span {
    font-weight: bold;
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--border-color);
    padding: 0.25em;
    margin: 0 0.5em 0.5em 0.5em;
}

div.ThemeList li.theme-group-header > span > span.icon {
    margin-right: 0.25em;
}

div.ThemeList ul.theme-group-body {
    padding: 0.25em;
}

div.ThemeList li.theme-group-header ul.theme-group-body {
    margin-left: 0.25em;
}

div.ThemeList li.theme-item {
    background-color: var(--list-bg-color);
    font-weight: bold;
    font-size: small;
    border: 1px solid var(--border-color);
    margin: 0.5em;
    text-align: center;
    display: inline-block;
    width: calc(15em + 2px);
    position: relative;
    border-radius: var(--border-radius);
}
div.ThemeList div.theme-item-title {
    display: flex;
    align-items: center;
}

div.ThemeList div.theme-item-title > span:first-child {
    flex: 1 1 auto;
    padding: 0.125em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

div.ThemeList div.theme-item-title > span.icon {
    flex: 0 0 auto;
    padding: 0.125em;
    font-size: large;
}

div.ThemeList div.theme-item-body {
    height: 7.5em;
    width: 15em;
}

div.ThemeList li.theme-item-active div.theme-item-title > span:first-child {
    color: var(--color-active);
}

div.ThemeList img.theme-item-thumbnail {
    width: 100%;
    height: auto;
    max-width: 15em;
    max-height: 7.5em;
    vertical-align: top;
    border-radius: 0px 0px var(--border-radius) var(--border-radius);
}

div.ThemeList div.theme-item-icons {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    max-height: 7.5em;
}

div.ThemeList div.theme-item-icons > span.icon {
    flex: 0 1 1.5em;
    padding: 0 0.25em;
    font-size: large;
    background-color: var(--button-bg-color);
    color: var(--text-color);
    z-index: 2;
    border-radius: 0px 0px var(--border-radius) 0px ;
}

div.ThemeList div.theme-item-icons > span.icon:hover {
    color: var(--color-active);
}

div.ThemeList li.theme-item:hover {
    border: 1px solid var(--color-active);
}

div.ThemeList div.theme-item-icons > span.icon-active {
    color: var(--color-active);
}

div.ThemeList div.theme-item-keywords {
    position: relative;
    display: inline-block;
    color: gray;
    font-size: x-small;
    font-weight: normal;
    max-width: 80%;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

div.ThemeList li.theme-item-active {
    border: 1px solid var(--color-active);
}

div.ThemeList div.theme-item-info-menu {
    text-align: left;
    display: flex;
    align-items: center;
    position: relative;
    color: var(--color-active);
    padding: 0.25em;
}

div.ThemeList div.theme-item-info-menu-active {
    background-color: var(--color-active);
    color: white;
}

div.ThemeList div.theme-item-info-menu > span.icon-info {
    margin-right: 0.25em;
}

div.ThemeList div.theme-item-info-menu > span.icon-triangle-down {
    margin-left: 0.25em;
    font-size: 80%;
}

div.ThemeList div.theme-item-info-links {
    position: absolute;
    top: 100%;
    max-width: calc(15em + 2px);
    left: -1px;
    right: -1px;
    background-color: rgba(255, 255, 255, 0.85);
    border: 1px solid var(--color-active);
}

div.ThemeList div.theme-item-info-links > a {
    display: block;
    text-align: left;
    padding: 0.25em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

div.ThemeList div.theme-item-filterinfo-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 2.29em;
    font-size: 90%;
    background-color: rgba(255, 255, 255, 0.85);
    color: black;
    font-weight: normal;
    text-align: left;
    padding: 0.25em;
    border-top: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
    z-index: 1;
}

div.ThemeList div.theme-item-filterinfo-overlay > div {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

div.ThemeList div.theme-item-filterinfo-overlay > div:not(:last-child) {
    padding-bottom: 0.25em;
}

div.ThemeList div.theme-item-restricted-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(127, 127, 127, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 400%;
}
`, "",{"version":3,"sources":["webpack://./components/style/ThemeList.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,4CAA4C;IAC5C,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,gBAAgB;IAChB,qCAAqC;IACrC,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;IACxC,wBAAwB;IACxB,UAAU;IACV,gDAAgD;AACpD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,2CAA2C;IAC3C,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,cAAc;IACd,2CAA2C;IAC3C,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yCAAyC;IACzC,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":["div.ThemeList ul {\n    padding: 0;\n    list-style-type: none;\n}\n\ndiv.ThemeList li.theme-group-header > span {\n    font-weight: bold;\n    display: flex;\n    align-items: center;\n    border-bottom: 1px solid var(--border-color);\n    padding: 0.25em;\n    margin: 0 0.5em 0.5em 0.5em;\n}\n\ndiv.ThemeList li.theme-group-header > span > span.icon {\n    margin-right: 0.25em;\n}\n\ndiv.ThemeList ul.theme-group-body {\n    padding: 0.25em;\n}\n\ndiv.ThemeList li.theme-group-header ul.theme-group-body {\n    margin-left: 0.25em;\n}\n\ndiv.ThemeList li.theme-item {\n    background-color: var(--list-bg-color);\n    font-weight: bold;\n    font-size: small;\n    border: 1px solid var(--border-color);\n    margin: 0.5em;\n    text-align: center;\n    display: inline-block;\n    width: calc(15em + 2px);\n    position: relative;\n    border-radius: var(--border-radius);\n}\ndiv.ThemeList div.theme-item-title {\n    display: flex;\n    align-items: center;\n}\n\ndiv.ThemeList div.theme-item-title > span:first-child {\n    flex: 1 1 auto;\n    padding: 0.125em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\ndiv.ThemeList div.theme-item-title > span.icon {\n    flex: 0 0 auto;\n    padding: 0.125em;\n    font-size: large;\n}\n\ndiv.ThemeList div.theme-item-body {\n    height: 7.5em;\n    width: 15em;\n}\n\ndiv.ThemeList li.theme-item-active div.theme-item-title > span:first-child {\n    color: var(--color-active);\n}\n\ndiv.ThemeList img.theme-item-thumbnail {\n    width: 100%;\n    height: auto;\n    max-width: 15em;\n    max-height: 7.5em;\n    vertical-align: top;\n    border-radius: 0px 0px var(--border-radius) var(--border-radius);\n}\n\ndiv.ThemeList div.theme-item-icons {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    flex-direction: column;\n    max-height: 7.5em;\n}\n\ndiv.ThemeList div.theme-item-icons > span.icon {\n    flex: 0 1 1.5em;\n    padding: 0 0.25em;\n    font-size: large;\n    background-color: var(--button-bg-color);\n    color: var(--text-color);\n    z-index: 2;\n    border-radius: 0px 0px var(--border-radius) 0px ;\n}\n\ndiv.ThemeList div.theme-item-icons > span.icon:hover {\n    color: var(--color-active);\n}\n\ndiv.ThemeList li.theme-item:hover {\n    border: 1px solid var(--color-active);\n}\n\ndiv.ThemeList div.theme-item-icons > span.icon-active {\n    color: var(--color-active);\n}\n\ndiv.ThemeList div.theme-item-keywords {\n    position: relative;\n    display: inline-block;\n    color: gray;\n    font-size: x-small;\n    font-weight: normal;\n    max-width: 80%;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\ndiv.ThemeList li.theme-item-active {\n    border: 1px solid var(--color-active);\n}\n\ndiv.ThemeList div.theme-item-info-menu {\n    text-align: left;\n    display: flex;\n    align-items: center;\n    position: relative;\n    color: var(--color-active);\n    padding: 0.25em;\n}\n\ndiv.ThemeList div.theme-item-info-menu-active {\n    background-color: var(--color-active);\n    color: white;\n}\n\ndiv.ThemeList div.theme-item-info-menu > span.icon-info {\n    margin-right: 0.25em;\n}\n\ndiv.ThemeList div.theme-item-info-menu > span.icon-triangle-down {\n    margin-left: 0.25em;\n    font-size: 80%;\n}\n\ndiv.ThemeList div.theme-item-info-links {\n    position: absolute;\n    top: 100%;\n    max-width: calc(15em + 2px);\n    left: -1px;\n    right: -1px;\n    background-color: rgba(255, 255, 255, 0.85);\n    border: 1px solid var(--color-active);\n}\n\ndiv.ThemeList div.theme-item-info-links > a {\n    display: block;\n    text-align: left;\n    padding: 0.25em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\ndiv.ThemeList div.theme-item-filterinfo-overlay {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 2.29em;\n    font-size: 90%;\n    background-color: rgba(255, 255, 255, 0.85);\n    color: black;\n    font-weight: normal;\n    text-align: left;\n    padding: 0.25em;\n    border-top: 1px solid var(--border-color);\n    border-right: 1px solid var(--border-color);\n    z-index: 1;\n}\n\ndiv.ThemeList div.theme-item-filterinfo-overlay > div {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\ndiv.ThemeList div.theme-item-filterinfo-overlay > div:not(:last-child) {\n    padding-bottom: 0.25em;\n}\n\ndiv.ThemeList div.theme-item-restricted-overlay {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-color: rgba(127, 127, 127, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 400%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
